import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source']

  copy(event) {
    event.preventDefault()

    if (this.sourceTarget) {
      const text = this.sourceTarget.textContent
      const trimmedText = text.trim()

      navigator.clipboard.writeText(trimmedText)
    }
  }
}
